class DeferredMedia extends HTMLElement {
  constructor() {
    super();

    this.isPlaying = false;
    this.abortController = undefined;

    this.deferredMediaPlayButton = this.querySelector(
      '[ref="deferredMediaPlayButton"]'
    );
    this.toggleMediaButton = this.querySelector('[ref="toggleMediaButton"]');
  }

  connectedCallback() {
    this.onDialogOpenUnsubscriber = subscribe(
      PUB_SUB_EVENTS.dialogOpen,
      this.handleForcedPause.bind(this)
    );
    this.onMenuOpenUnsubscriber = subscribe(
      PUB_SUB_EVENTS.menuOpen,
      this.handleForcedPause.bind(this)
    );
    this.abortConroller = new AbortController();
    const signal = this.abortConroller.signal;
    document.addEventListener(
      "media-start-playing",
      this.pauseMedia.bind(this),
      { signal }
    );
    window.addEventListener("dialog-closed", this.pauseMedia.bind(this), {
      signal,
    });
    this.registerEvents();
    this.deferredMediaPlayButton.classList.remove("hidden");
    this.toggleMediaButton.classList.add("hidden");
  }

  disconnectedCallback() {
    if (this.onDialogOpenUnsubscriber)
      this.onDialogOpenUnsubscriber.unsubscribe();
    if (this.onMenuOpenUnsubscriber) this.onMenuOpenUnsubscriber.unsubscribe();
    this.abortConroller.abort();
    this.unregisterEvents();
    this.deferredMediaPlayButton.classList.add("hidden");
    this.toggleMediaButton.classList.add("hidden");
  }

  registerEvents() {
    this.deferredMediaPlayButton.addEventListener(
      "click",
      this.handlePlayButtonClick.bind(this)
    );
    this.toggleMediaButton.addEventListener(
      "click",
      this.handleToggleButtonClick.bind(this)
    );
  }

  unregisterEvents() {
    this.deferredMediaPlayButton.addEventListener(
      "click",
      this.handlePlayButtonClick.bind(this)
    );
    this.toggleMediaButton.addEventListener(
      "click",
      this.handleToggleButtonClick.bind(this)
    );
  }

  handlePlayButtonClick() {
    this.showDeferredMedia();
  }

  handleToggleButtonClick() {
    this.toggleMedia();
  }

  handleForcedPause() {
    this.toggleMedia();
  }

  updatePlayPauseHint(isPlaying) {
    if (this.toggleMediaButton) {
      const playIcon = this.toggleMediaButton.querySelector(".icon-play");
      if (playIcon) playIcon.classList.toggle("hidden", isPlaying);
      const pauseIcon = this.toggleMediaButton.querySelector(".icon-pause");
      if (pauseIcon) pauseIcon.classList.toggle("hidden", !isPlaying);
    }
  }

  showDeferredMedia() {
    this.loadContent(true);
    this.isPlaying = true;
    this.updatePlayPauseHint(this.isPlaying);
  }

  loadContent(focus = true) {
    if (this.getAttribute("data-media-loaded")) return;
    this.dispatchEvent(new Event("media-started-playing"));

    const content =
      this.querySelector("template")?.content.firstElementChild?.cloneNode(
        true
      );

    if (!content) return;

    this.setAttribute("data-media-loaded", "true");
    this.appendChild(content);

    if (focus && content instanceof HTMLElement) {
      content.focus();
    }

    this.classList.add("is-playing");

    if (
      content instanceof HTMLVideoElement &&
      content.getAttribute("autoplay")
    ) {
      content.play();
    }
  }

  toggleMedia() {
    if (this.isPlaying) {
      this.pauseMedia();
    } else {
      this.playMedia();
    }
  }

  playMedia() {
    /** @type {HTMLIFrameElement | null} */
    const iframe = this.querySelector("iframe[data-video-type]");
    if (iframe) {
      iframe.contentWindow?.postMessage(
        iframe.dataset.videoType === "youtube"
          ? '{"event":"command","func":"playVideo","args":""}'
          : '{"method":"play"}',
        "*"
      );
    } else {
      this.querySelector("video")?.play();
    }
    this.isPlaying = true;
    this.updatePlayPauseHint(this.isPlaying);
  }

  pauseMedia() {
    /** @type {HTMLIFrameElement | null} */
    const iframe = this.querySelector("iframe[data-video-type]");
    if (iframe) {
      iframe.contentWindow?.postMessage(
        iframe.dataset.videoType === "youtube"
          ? '{"event":"command","func":"' + "pauseVideo" + '","args":""}'
          : '{"method":"pause"}',
        "*"
      );
    } else {
      this.querySelector("video")?.pause();
    }
    this.isPlaying = false;
    if (this.getAttribute("data-media-loaded")) {
      this.updatePlayPauseHint(this.isPlaying);
    }
  }
}
if (!customElements.get("deferred-media")) {
  customElements.define("deferred-media", DeferredMedia);
}
